export default __webpack_public_path__ + "static/media/27.fc16e15a.png";